var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { API, encode } from "@lysaab/ui-2";
export function netsInitiateSignup(country, signupId, state) {
    return API.post(encode(templateObject_1 || (templateObject_1 = __makeTemplateObject(["/nets/onboarding/initiate/", ""], ["/nets/onboarding/initiate/", ""])), country.toString().toLowerCase()), {
        signupId: signupId,
        state: state,
    });
}
export function netsInitiateLogin(country, state) {
    return API.post("/nets/login/initiate/".concat(country.toString().toLowerCase()).concat(state ? "?state=".concat(state) : ""));
}
export function netsDoneSignup(country, extra) {
    var extraParams = Object.entries(extra)
        .map(function (_a) {
        var key = _a[0], value = _a[1];
        return "".concat(key, "=").concat(encodeURIComponent(value));
    })
        .join("&");
    var encodedCountry = encodeURIComponent(country.toLowerCase());
    var url = "/nets/callback/".concat(encodedCountry, "/signup/done?").concat(extraParams);
    return Promise.allSettled([
        API.get(url, true),
        Promise.resolve(url),
    ]);
}
export function netsDoneLogin(country, extra) {
    var extraParams = Object.entries(extra)
        .map(function (_a) {
        var key = _a[0], value = _a[1];
        return "".concat(key, "=").concat(encodeURIComponent(value));
    })
        .join("&");
    var encodedCountry = encodeURIComponent(country.toLowerCase());
    var url = "/nets/callback/".concat(encodedCountry, "/login/done?").concat(extraParams);
    return Promise.allSettled([
        API.get(url, true),
        Promise.resolve(url),
    ]);
}
export var NetsStatus;
(function (NetsStatus) {
    NetsStatus["SUCCESS"] = "SUCCESS";
    NetsStatus["INITIATED"] = "INITIATED";
    NetsStatus["FAILED_INTERNAL"] = "FAILED_INTERNAL";
    NetsStatus["TIMED_OUT"] = "TIMED_OUT";
})(NetsStatus || (NetsStatus = {}));
export function netsStatus(state) {
    return API.get(encode(templateObject_2 || (templateObject_2 = __makeTemplateObject(["/nets/status/auth/", ""], ["/nets/status/auth/", ""])), state), true);
}
var templateObject_1, templateObject_2;
